const Loader = () => (
  <div
    className="t-absolute t-top-0 t-w-[100vw] t-h-[100vh] t-flex t-items-center t-justify-center t-z-50 t-overflow-hidden"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="t-flex t-gap-1.5">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="t-inline-block t-w-2 t-h-2 t-rounded-full t-bg-white t-animate-bounce"
          style={{ animationDelay: `${i * 150}ms` }}
        />
      ))}
    </div>
  </div>
);

export default Loader;
